function fetchPropSummary(pagination, filtersPage, sorterPage){

    var returnObj = {};
    
    returnObj.limit = pagination.pageSize;
    returnObj.offset = (pagination.current - 1)*pagination.pageSize;   
    
    if (Object.getOwnPropertyNames(sorterPage).length != 0) {
      if(sorterPage.order == 'descend'){ returnObj.order = [[sorterPage.field, "DESC"]] }
      if(sorterPage.order == 'ascend'){  returnObj.order = [[sorterPage.field]] }
    }
    for (var name in filtersPage){
      if (filtersPage[name]&&filtersPage[name].length>0){ returnObj[name] = filtersPage[name];  }
    }
    return returnObj;
}


export default fetchPropSummary;